export default __webpack_public_path__ + "static/media/inspire_web-sm@2x.d44224e9.webp";